import { useRef, useCallback, useEffect } from 'react';

/**
 * This hook method is set and reset the timeout for  onchange value in numeric control
 * @param callback onchange method to call after timeout is completed
 * @param {number} delay timeout value
 */
export function useDebounce<T extends (...args: any[]) => void>(callback: T, delay: number) {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);

  //Set the timeout value when change the value in the input text box
  const debounceCallback = useCallback(
    (...args: Parameters<T>) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        callback(...args);
      }, delay);
    },
    [callback, delay]
  );

  //Clear existing timeout when render this hook method
  useEffect(() => {
    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, []);

  return debounceCallback;
}
